import { simpleCopy } from '@/utils/deepCopy';
import { IBusiness } from './entities/businessBase';
import { IYearMonth } from './date';
import { DateService } from './services/dateService';

/**
 * 取引情報の総件数
 * @param baseBusinessArray - 取引情報一覧
 * @returns number - 関連取引件数
 */
const totalBusinessResult = async (baseBusinessArray: IBusiness[]): Promise<number> => {
  const businessArray = simpleCopy(baseBusinessArray);
  // TODO: 本当はこっちで取りたいが、登録済み取引に未転記取引が含まれている(集計行が無い取引情報が追加されている)ので一旦関連取引を展開する方針で進める
  // const filteredBusinesses = businessArray.filter((ent) => ent.aggregateGroup);
  const aggregateBusinessBusinesses = businessArray.filter((ent) => ent.aggregateGroup && ent.aggregateGroup.length > 0);

  // 関連取引の合計
  let total = 0;
  // 関連取引の数を集計する

  for (const aggregateBusinessBusiness of aggregateBusinessBusinesses) {
    total += aggregateBusinessBusiness.aggregateGroup ? aggregateBusinessBusiness.aggregateGroup.length : 0; // 関連取引情報を持っていたら、配列長を加算する
  }
  return total;
};

/**
 * 達成件数の計算
 * @param baseBusinessArray - 取引情報一覧
 * @param targetCreateYearMonth - 対象の作成年月
 */
const achieveBusinessCountForTargetYearMonth = async (
  baseBusinessArray: IBusiness[],
  targetCreateYearMonth: IYearMonth
): Promise<number> => {
  const businessArray = simpleCopy(baseBusinessArray);

  // 集計行取引情報を取得
  const aggregateBusinesses = businessArray.filter((ent) => ent.aggregateGroup && ent.aggregateGroup.length > 0);

  let total = 0; // 合計

  // 集計行に連なる関連取引数の計算
  for (const aggregateBusiness of aggregateBusinesses) {
    if (aggregateBusiness.aggregateGroup && aggregateBusiness.supplierAnnounce) {
      // 対象月の仕入先内示が確定されているかどうかを判定
      const isSupplierForecast =
        aggregateBusiness.supplierAnnounce.filter((ent) => {
          // 管理開始年月情報が選択年月と同じかを判定する
          // undefinedなら必ずfalseを返すようにしている
          if (ent.manageInitiatedYearMonth) {
            return DateService.equalYearMonthInfo(ent.manageInitiatedYearMonth, targetCreateYearMonth as IYearMonth);
          }
          return false;
        }).length > 0;
      if (isSupplierForecast) {
        total += aggregateBusiness.aggregateGroup.length;
      }
    }
  }
  return total;
};

export { totalBusinessResult, achieveBusinessCountForTargetYearMonth };
